import PhoneInput from "components/atoms/PhoneInput";
import { useEffect, useState } from "react";
import  i18next  from 'i18next';
import { fieldHelperText } from "utils/fieldError.util";
import RequiredMark from "components/atoms/RequiredMark";
import "styles/yeloplus-field-error.scss";

export default function PhoneInputRedux({
	id,
	input,
	label,
	handleBlur,
	handleFocus,
	PhoneInputProps,
	className,
	showAsterisk,
	required,
	meta: { error, touched, invalid, submitFailed },
}: any) {

	const [cError , setCError] = useState(i18next.t(`${error}`));
	const [currentLanguage,setCurrlang]=useState(i18next.language);

	

	if(currentLanguage !== i18next.language){
		setCurrlang(i18next.language)
	}
	useEffect(()=>{
		setCError(i18next.t(`${error}`));
	},[error,currentLanguage])


	const showError = Boolean(invalid && error && (submitFailed || touched));
	const helperText = fieldHelperText(showError, error, cError);
	const phoneInputProps = { ...(PhoneInputProps ?? {}) };
	delete phoneInputProps.variant;

	return (
		<div
			className={[
				"field",
				"phone-field",
				"yelo-phone-field",
				showError ? "is-invalid" : "",
				className,
			]
				.filter(Boolean)
				.join(" ")}
		>
			{label ? (
				<span>
					{label}
					{required || showAsterisk ? <RequiredMark /> : null}
				</span>
			) : null}
			<PhoneInput
				{...phoneInputProps}
				id={id}
				ariaRequired={Boolean(required || showAsterisk)}
				name={input?.name}
				specialLabel=""
				value={input?.value?.value}
				error={showError}
				onBlur={(e) => {
					input?.onBlur?.(input?.value);
					handleBlur?.(e);
					e.preventDefault();
				}}
				onFocus={(e) => {
					input?.onFocus?.(e);
					handleFocus?.(e);
					e.preventDefault();
				}}
				onChange={(value, data, _e, formattedValue) => {
					input.onChange({ value, data, formattedValue });
				}}
			/>
			{helperText ? (
				<p className="field-error" role="alert">
					{helperText}
				</p>
			) : null}
		</div>
	);
}
